export default function WeeDance() {
	return (
		<div className="px-6 sm:px-8">
			<div className="mx-auto max-w-2xl pt-4 text-center">
				<h2 className="text-2xl font-bold tracking-tight text-white sm:text-4xl">
					Wee Dance
				</h2>
				<p className="text-[#f9c04d]">(Age 18-36 months)</p>
				<p className="mt-6 text-sm font-bold text-stone-300 sm:text-base">
					A creative movement class that introduces your little one to music,
					dancing and fun with friends!
				</p>
			</div>
			<div className="mt-8 border-t border-stone-600 font-bold">
				<dl className="divide-y divide-stone-600">
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Creative Movement</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Wednesdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">9:45-10:15am</div>
							</div>
						</dd>
					</div>
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Creative Movement</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Wednesdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">4:15-4:45pm</div>
							</div>
						</dd>
					</div>
				</dl>
				<div className="mx-auto max-w-xl space-y-4 pt-12 text-center">
					<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
						<div>
							<span className="text-[#f9c04d]">** </span>July 8, 15, 22, 29,
							August 5
						</div>
					</div>
					<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
						<div>Drop in fee: $14</div>
						<div>Five week session: $65</div>
					</div>
				</div>
			</div>
		</div>
	)
}
